import { get, post } from '../../utils/axios'

export const listSettingCostCenterAPI = async (body) => {
  return await get('cost/center', body)
}

export const dropSettingCostCenterGroupAPI = async () => {
  return await get('cost/center/group')
}

export const createSettingCostCenterAPI = async (body) => {
  return await post('cost/center', body)
}

export const updateSettingCostCenterAPI = async (body) => {
  return await post('cost/center/update', body)
}

export const delSettingCostCenterAPI = async (body) => {
  return await post('cost/center/delete', body)
}
